import { useCallback, useEffect } from 'react';

import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import authAtom from '~/recoil/atom/auth';
import customerAtom from '~/recoil/atom/customer';

import initCustomer from '~/firebase/initialDoc/initCustomer';
import customerListener from '~/firebase/listeners/customer';
import { PLATFORM_ID } from '~/globalVariables';

import { SnapshotFn } from '~/firebase/listeners/type';
import { Customer } from '~/types/platform/customer';

export default function useCustomer() {
  const auth = useRecoilValue(authAtom);

  const setCustomer = useSetRecoilState(customerAtom);
  const resetCustomer = useResetRecoilState(customerAtom);

  const handleSetCustomer = useCallback<SnapshotFn>(
    (snap) => {
      console.log('useCustomer auth', auth);
      const data = snap.data() as Customer | undefined;
      if (snap.exists() && data) {
        setCustomer(data);
        return;
      }
      if (auth) {
        initCustomer(PLATFORM_ID, auth);
      }
    },
    [setCustomer, auth],
  );

  useEffect(() => {
    if (auth) {
      const unListen = customerListener(PLATFORM_ID, auth, handleSetCustomer);

      return unListen;
    }

    resetCustomer();
  }, [auth, handleSetCustomer, resetCustomer]);
}
